
/*
 * Retro Chic / MaxBundle Cart Sync V3
 * Waits for cart changes to settle before opening.
 * Does not add products or modify global fetch/XHR.
 */
(function () {
  'use strict';

  if (window.__rcMaxBundleCartSyncV3) return;
  window.__rcMaxBundleCartSyncV3 = true;

  var attemptId = 0;
  var latestCart = null;
  var root = (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) || '/';

  if (root.slice(-1) !== '/') root += '/';

  var POLL_MS = 400;
  var QUIET_MS = 2000;
  var MIN_WAIT_MS = 2400;
  var MAX_WAIT_MS = 20000;
  var AFTER_OPEN_MS = 5000;

  function readCart() {
    return fetch(root + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart HTTP ' + response.status);
      }
      return response.json();
    });
  }

  function cartSignature(cart) {
    return (cart.items || []).map(function (item) {
      return String(item.key || item.id) +
        ':' + String(item.quantity);
    }).sort().join('|');
  }

  function cartEnabled() {
    return !!document.querySelector(
      '.js-mini-cart[data-cartmini="true"]'
    );
  }

  function renderAndOpen() {
    if (
      !cartEnabled() ||
      !window.theme ||
      !window.theme.miniCart
    ) return;

    var miniCart = window.theme.miniCart;

    if (
      typeof miniCart.generateCart !== 'function' ||
      typeof miniCart.updateElements !== 'function'
    ) return;

    miniCart.generateCart();
    miniCart.updateElements();

    document.querySelectorAll(
      '.js-mini-cart[data-cartmini="true"]'
    ).forEach(function (el) {
      el.classList.add('active');
    });
  }

  // Read initial cart state
  readCart().then(function (cart) {
    latestCart = cart;
  }).catch(function () {});

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (
      !target ||
      typeof target.closest !== 'function' ||
      !target.closest('.mb_mix_bundle_btn') ||
      !cartEnabled()
    ) return;

    var myAttempt = ++attemptId;
    var start = Date.now();
    var snapshot = latestCart;

    function monitor(baseline) {
      if (myAttempt !== attemptId) return;

      var baseCount = baseline.item_count || 0;
      var observedSignature = cartSignature(baseline);
      var changedAt = start;
      var opened = false;
      var openedAt = 0;
      var lastRenderedSignature = null;

      function poll() {
        if (myAttempt !== attemptId) return;

        if (Date.now() - start > MAX_WAIT_MS) {
          if (!opened) {
            console.warn(
              '[RC MaxBundle] Cart did not change within 20 seconds.'
            );
          }
          return;
        }

        readCart().then(function (cart) {
          if (myAttempt !== attemptId) return;

          latestCart = cart;

          var now = Date.now();
          var signature = cartSignature(cart);
          var count = cart.item_count || 0;

          if (signature !== observedSignature) {
            observedSignature = signature;
            changedAt = now;
          }

          var added = count > baseCount;

          // Wait until the cart stops changing
          if (
            !opened &&
            added &&
            now - start >= MIN_WAIT_MS &&
            now - changedAt >= QUIET_MS
          ) {
            opened = true;
            openedAt = now;
            lastRenderedSignature = signature;
            renderAndOpen();

          } else if (
            opened &&
            added &&
            signature !== lastRenderedSignature
          ) {
            // Catch later additions from a bundle
            lastRenderedSignature = signature;
            renderAndOpen();
          }

          // Continue briefly after opening
          if (
            opened &&
            now - openedAt >= AFTER_OPEN_MS &&
            now - changedAt >= QUIET_MS
          ) return;

          setTimeout(poll, POLL_MS);

        }).catch(function () {
          if (myAttempt === attemptId) {
            setTimeout(poll, POLL_MS);
          }
        });
      }

      setTimeout(poll, 300);
    }

    if (snapshot) {
      monitor(snapshot);
    } else {
      readCart().then(function (cart) {
        if (myAttempt !== attemptId) return;
        latestCart = cart;
        monitor(cart);
      }).catch(function (error) {
        console.warn(
          '[RC MaxBundle] Could not read cart:',
          error
        );
      });
    }

  }, true);

})();
